// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':id/investment-sales',
        component: () =>
            import(/* webpackChunkName: "investment.investment-sales" */ '@/pages/[organisation]/investment/investment-sales/investment-sales.vue'),
        name: 'investment.investment-sales.search-investment-sales',
        meta: {
            loginRequired: true,
            permission: 'access.finance.investment.investment-sales.view-investment-sales',
        },
    },

    {
        path: ':id/record-sale',
        component: () =>
            import(/* webpackChunkName: "investment.investment-sales" */ '@/pages/[organisation]/investment/investment-sales/investment-sale/new.vue'),
        name: 'investment.investment-sales.create-investment-sale',
        meta: {
            loginRequired: true,
            permission: 'access.finance.investment.investment-sales.create-investment-sale',
        },
    },
];
